{
  "health": {
    "ON_TRACK": "On track",
    "AT_RISK": "At risk",
    "OFF_TRACK": "Off track",
    "NOT_MEASURED": "Not measured",
    "trigger": "Health: {{level}}. Why?",
    "whyTitle": "Why the project is {{level}}",
    "rule": "Overall health is the worst of cost, schedule, billing and contract. Delivery and record keeping raise it to At risk at most.",
    "notMeasured": {
      "NO_BUDGET": "Not measured until a budget is approved.",
      "NO_DATES": "Not measured until the plan has dates.",
      "NOT_ACTIVE": "Measured only while the project is active."
    },
    "stillListed": "Alerts still show under Needs attention.",
    "dimension": {
      "cost": "Cost",
      "schedule": "Schedule",
      "billing": "Billing and cash",
      "contract": "Contract",
      "delivery": "Delivery",
      "hygiene": "Record keeping"
    },
    "level": {
      "none": "Fine",
      "info": "Note",
      "warning": "Warning",
      "critical": "Critical"
    },
    "hidden": "The reasons need permission to see project money.",
    "asOf": "Checked {{date}}"
  },
  "attention": {
    "since": "Since {{date}}",
    "failed": "Alerts couldn't be checked, so only the plan's dates are shown."
  },
  "alerts": {
    "label": "Project alerts",
    "seeAll": "See all in Needs attention",
    "count_one": "{{n}} alert",
    "count_other": "{{n}} alerts",
    "seeAllShort": "See all"
  },
  "units": {
    "workingDays_one": "{{n}} working day",
    "workingDays_other": "{{n}} working days",
    "days_one": "{{n}} day",
    "days_other": "{{n}} days",
    "points_one": "{{n}} point",
    "points_other": "{{n}} points",
    "invoices_one": "{{n}} invoice",
    "invoices_other": "{{n}} invoices",
    "tasks_one": "{{n}} task",
    "tasks_other": "{{n}} tasks",
    "blockedTasks_one": "{{n}} task",
    "blockedTasks_other": "{{n}} tasks",
    "overdueTasks_one": "{{n}} task",
    "overdueTasks_other": "{{n}} tasks",
    "documents_one": "{{n}} document",
    "documents_other": "{{n}} documents",
    "hours_one": "{{n}} hour",
    "hours_other": "{{n}} hours",
    "hoursNote": " It includes {{hours}} of time."
  },
  "signal": {
    "BURN_AHEAD": {
      "title": "Spend is {{gapPts}} ahead of progress",
      "detail": "{{spentPct}}% of the budget is spent for {{progressPct}}% of the work done.",
      "action": "See costs",
      "short": "Spend ahead of progress"
    },
    "BUDGET_EXCEEDED": {
      "title": "Over budget by {{overPct}}%",
      "detail": "Spent {{ac}} against a budget of {{bac}}.",
      "action": "New budget version",
      "short": "Over budget"
    },
    "CATEGORY_EXCEEDED": {
      "title": "{{category}} is near or over its budget",
      "detail": "Spent {{actual}} and ordered {{committed}} against a budget of {{budget}}.",
      "action": "See the category",
      "titleOver": "{{category}} is over its budget, at {{pct}}",
      "titleNear": "{{category}} is near its budget, at {{pct}}",
      "detailNoOrders": "Spent {{actual}} against a budget of {{budget}}.",
      "short": "A cost category over budget"
    },
    "FORECAST_LOSS": {
      "title": "Heading for a loss of {{loss}}",
      "detail": "The expected final cost of {{eac}} is more than the expected revenue of {{rac}}.",
      "action": "See the forecast",
      "short": "Heading for a loss"
    },
    "MARGIN_EROSION": {
      "title": "Margin falling to {{forecastPct}}%",
      "detail": "The budget planned a {{baselinePct}}% margin; at the current rate it will be {{forecastPct}}%.",
      "action": "See costs",
      "short": "Margin shrinking"
    },
    "MILESTONE_OVERDUE": {
      "title": "{{milestone}} is {{daysLate}} late",
      "detail": "Planned for {{plannedOn}} and not achieved yet.",
      "action": "Open in the plan",
      "short": "Milestone late"
    },
    "SCHEDULE_SLIP": {
      "title": "Finish slipping by {{slipDays}}",
      "detail": "Expected to finish on {{forecastOn}} instead of {{plannedOn}}; work is moving at {{spiT}} of the planned pace.",
      "action": "Open the plan",
      "short": "Finish slipping"
    },
    "MILESTONE_UNBILLED": {
      "title": "{{milestone}} is done but not invoiced",
      "detail": "Achieved on {{doneOn}}; {{amount}} is ready to bill.",
      "action": "Invoice milestone",
      "short": "Done but not invoiced"
    },
    "TM_UNBILLED": {
      "title": "{{amount}} of billable work not invoiced",
      "detail": "The oldest item is from {{oldestOn}}.{{hours}}",
      "action": "Bill the work",
      "short": "Billable work waiting"
    },
    "RECEIVABLE_OVERDUE": {
      "title": "{{amount}} overdue from the customer",
      "detail": "{{count}} past due, the oldest by {{maxDays}}.",
      "action": "See invoices",
      "short": "Customer paying late"
    },
    "PROJECT_STALE": {
      "title": "No activity for {{days}}",
      "detail": "Nothing recorded since {{lastActivityOn}}: no progress, costs or tasks.",
      "action": "Update progress",
      "short": "No recent activity"
    },
    "TASKS_BLOCKED": {
      "title": "{{count}} blocked",
      "detail": "The oldest has been blocked for {{oldestDays}}.",
      "action": "See tasks",
      "short": "Tasks blocked"
    },
    "TASKS_OVERDUE": {
      "title": "{{count}} overdue",
      "detail": "The oldest is {{oldestDays}} past its due date.",
      "action": "See tasks",
      "short": "Tasks overdue"
    },
    "UNASSIGNED_COSTS": {
      "title": "{{amount}} may belong to this project",
      "detail": "Not on any project: {{count}} from this project's customer or suppliers, dated within the project's dates.",
      "action": "Review costs",
      "short": "Documents without a project"
    },
    "NO_APPROVED_BUDGET": {
      "title": "No approved budget",
      "detail": "Approve a budget to measure cost and progress against it.",
      "action": "Open the budget",
      "short": "No approved budget"
    },
    "TIME_NOT_SUBMITTED": {
      "title": "{{member}} hasn't submitted last week's time",
      "detail": "{{submitted}} of the {{expected}} expected were submitted for the week of {{weekStart}}.",
      "action": "Open the Time tab",
      "short": "Time not submitted"
    },
    "RETENTION_DUE": {
      "title": "Retention of {{amount}} is due for release",
      "detail": "Release date {{dueOn}}, and no release invoice yet.",
      "action": "Release retention",
      "titleSoon": "Retention of {{amount}} falls due on {{dueOn}}",
      "short": "Retention due"
    },
    "BOND_EXPIRING": {
      "title": "{{bondType}} {{ref}} expires on {{expiresOn}}",
      "detail": "Have the bank extend it, or have it released, before it lapses.",
      "action": "Open guarantees",
      "titleExpired": "{{bondType}} {{ref}} expired on {{expiresOn}}",
      "detailExpired": "It no longer covers the contract: extend it, or record its release.",
      "short": "Guarantee expiring"
    },
    "CLAIM_NOT_CERTIFIED": {
      "title": "{{claim}} not certified after {{days}}",
      "detail": "Submitted on {{submittedOn}} for {{amount}}.",
      "action": "Record certification",
      "short": "Claim not certified"
    },
    "VARIATION_PENDING": {
      "title": "{{variation}} waiting {{days}} for the client's decision",
      "detail": "A variation of {{amount}} is still undecided.",
      "action": "Open the variation",
      "short": "Variation undecided"
    },
    "ADVANCE_RECOVERY_BEHIND": {
      "title": "Advance recovery is behind progress",
      "detail": "{{recoveredPct}}% of the advance recovered at {{progressPct}}% progress; {{outstanding}} still to recover.",
      "action": "Open retention and advance",
      "short": "Advance recovery behind"
    }
  },
  "forecast": {
    "title": "Forecast in words",
    "datesOnly": "Dates only: forecasts of money need permission to see project money.",
    "tooEarly": "Too early to forecast cost: {{progress}} of the work is done and {{spent}} of the budget is spent; cost forecasts start once both reach {{min}}. Until then the expected final cost is the budget.",
    "notEnough": "Not enough data yet.",
    "notMeasured": {
      "NO_BUDGET": "Forecasts start once a budget is approved.",
      "NO_DATES": "Forecasts start once the plan has dates.",
      "NOT_ACTIVE": "Forecasts start once the project is active."
    },
    "how": "How is this calculated?",
    "efficiency": {
      "label": "Work for the money",
      "tooEarly": "Too early to judge: wait until both the work done and the budget spent reach {{min}}.",
      "text": "For every {{spent}} spent, {{earned}} of work was done.",
      "how": "Work done is progress ({{progress}}) × budget ({{bac}}) = {{ev}}. Spent to date is {{ac}}. Work done ÷ spent = {{ratio}}."
    },
    "schedule": {
      "label": "Against plan",
      "behind": "{{days}} behind plan.",
      "ahead": "{{days}} ahead of plan.",
      "onPlan": "On plan.",
      "how": "The expected finish ({{forecast}}) against the planned finish ({{planned}}), counted in working days of the company calendar."
    },
    "finalCost": {
      "label": "Expected final cost",
      "over": "Expected final cost {{eac}} ({{diff}} over budget).",
      "under": "Expected final cost {{eac}} ({{diff}} under budget).",
      "onBudget": "Expected final cost {{eac}}, on budget.",
      "how": {
        "CPI": "Budget {{bac}} ÷ cost efficiency {{cpi}} (value earned per rial spent). It assumes the rest of the work costs what the work so far did.",
        "REMAINING_AT_BUDGET": "Spent {{ac}} + the budget of the work left ({{bac}} − {{ev}} of work done).",
        "CPI_SPI": "Spent {{ac}} + the work left ({{bac}} − {{ev}}) ÷ (cost efficiency {{cpi}} × pace {{spi}})."
      }
    },
    "finish": {
      "label": "Expected finish",
      "text": "Expected finish {{forecast}} (planned {{planned}}).",
      "noPlan": "No planned finish date yet.",
      "none": "No expected finish yet: no work has been earned recently.",
      "how": "The planned working days stretched by the pace of the work so far ({{pace}} of the plan), on the company calendar."
    },
    "margin": {
      "label": "Expected margin",
      "text": "Expected margin {{forecast}}% (budgeted {{baseline}}%).",
      "how": "(Expected revenue {{rac}} − expected final cost {{eac}}) ÷ expected revenue."
    },
    "expert": "Earned-value figures",
    "metric": {
      "progressPct": "Progress",
      "bac": "BAC · budget at completion",
      "pv": "PV · planned value today",
      "ev": "EV · earned value",
      "ac": "AC · actual cost",
      "cpi": "CPI · cost performance",
      "spi": "SPI · schedule performance",
      "spiT": "SPI(t) · time-based schedule performance",
      "eac": "EAC · estimate at completion",
      "etc": "ETC · estimate to complete",
      "vac": "VAC · variance at completion",
      "eacMethod": "EAC method"
    },
    "eacMethod": {
      "CPI": "BAC ÷ CPI",
      "REMAINING_AT_BUDGET": "AC + (BAC − EV)",
      "CPI_SPI": "AC + (BAC − EV) ÷ (CPI × SPI)"
    },
    "failed": "The forecast couldn't be loaded.",
    "retry": "Try again"
  },
  "curve": {
    "label": "Cost curve: planned, earned and spent to date",
    "caption": "Planned, earned and spent by month, cumulative, in Omani rials",
    "planned": "Planned",
    "earned": "Earned",
    "spent": "Spent",
    "forecast": "Forecast",
    "budget": "Budget",
    "today": "Today",
    "month": "Month",
    "empty": "The curve appears once the project has an approved budget and planned dates.",
    "failed": "The curve couldn't be loaded.",
    "how": "Planned spreads each phase's budget over its working days. Earned is progress × budget. Spent is posted cost. The dashed line runs from today to the expected final cost at the expected finish.",
    "weekly": "Weekly, as recorded each Saturday, with today's figures.",
    "monthly": "Monthly, worked out from today's figures. Weekly records take over once two weeks are recorded.",
    "monthlyFallback": "The weekly record couldn't be loaded; showing the monthly curve.",
    "captionWeekly": "Planned, earned and spent by week, cumulative, in Omani rials",
    "week": "Week",
    "liveRow": "Today, {{date}}",
    "calcChanged": "Calculated differently before {{date}}"
  },
  "week": {
    "of": "Week of {{day}}"
  },
  "changes": {
    "title": "What changed this week",
    "titleThat": "What changed that week",
    "week": "Week",
    "thisWeek": "{{week}} (this week)",
    "basisLive": "Today's figures against the record of {{date}}.",
    "basisWeek": "The record of {{to}} against the one of {{from}}.",
    "basisFirst": "The first record, of {{date}}.",
    "calcChanged": "The calculation changed between the two records, so part of the difference comes from the new formulas.",
    "health": "Health",
    "healthWent": "Health went from {{before}} to {{after}}.",
    "healthHeld": "Health stayed {{level}}.",
    "better": "Better",
    "worse": "Worse",
    "same": "No change",
    "signals": "Alerts",
    "kind": {
      "new": "New",
      "resolved": "Resolved",
      "escalated": "Worse",
      "eased": "Eased"
    },
    "upFrom": "Up from {{level}}",
    "downFrom": "Down from {{level}}",
    "figures": "Figures",
    "figuresCaption": "The figures that changed, before and after",
    "figure": "Figure",
    "before": "Before",
    "after": "After",
    "change": "Change",
    "label": {
      "progressPct": "Progress",
      "ac": "Spent to date",
      "committed": "Committed",
      "eac": "Expected final cost",
      "forecastMarginPct": "Expected margin",
      "forecastFinish": "Expected finish",
      "slipDays": "Against plan",
      "billed": "Billed",
      "collected": "Collected"
    },
    "late_one": "{{n}} working day late",
    "late_other": "{{n}} working days late",
    "ahead_one": "{{n}} working day ahead",
    "ahead_other": "{{n}} working days ahead",
    "onPlan": "On plan",
    "later_one": "{{n}} day later",
    "later_other": "{{n}} days later",
    "earlier_one": "{{n}} day earlier",
    "earlier_other": "{{n}} days earlier",
    "deltaPoints_one": "{{n}} point",
    "deltaPoints_other": "{{n}} points",
    "deltaWorkingDays_one": "{{n}} working day",
    "deltaWorkingDays_other": "{{n}} working days",
    "events": "What happened",
    "event": {
      "STATUS_CHANGED": "Status changed to {{status}}",
      "MILESTONE_ACHIEVED": "Milestone achieved: {{label}}",
      "PROGRESS_UPDATED": "Progress updated: {{label}}",
      "BUDGET_APPROVED": "Budget {{label}} approved",
      "VARIATION_DECIDED": "Variation {{label}} decided",
      "CLAIM_CERTIFIED": "Claim {{label}} certified",
      "INVOICE_ISSUED": "Invoice {{label}} issued",
      "TIME_APPROVED": "Time approved: {{label}}",
      "MEMBER_ADDED": "{{label}} joined the team"
    },
    "eventPlain": {
      "STATUS_CHANGED": "Status changed",
      "MILESTONE_ACHIEVED": "A milestone was achieved",
      "PROGRESS_UPDATED": "Progress was updated",
      "BUDGET_APPROVED": "A budget was approved",
      "VARIATION_DECIDED": "A variation was decided",
      "CLAIM_CERTIFIED": "A claim was certified",
      "INVOICE_ISSUED": "An invoice was issued",
      "TIME_APPROVED": "Time was approved",
      "MEMBER_ADDED": "Someone joined the team"
    },
    "variation": {
      "APPROVED": "Variation {{label}} approved",
      "REJECTED": "Variation {{label}} rejected"
    },
    "progressTo": "{{label}} updated to {{pct}}%",
    "budgetVersion": "Budget version {{n}} approved",
    "timeOf": "Time approved for {{person}}: {{duration}}",
    "by": "By {{name}}",
    "nothing": "Nothing changed this week.",
    "nothingThat": "Nothing changed that week.",
    "first": "The first recorded week: nothing to compare yet.",
    "noRecord": "No record for that week.",
    "failed": "What changed couldn't be loaded."
  },
  "burn": {
    "title": "Budget burn by category",
    "open": "Budget & cost",
    "of": "{{used}} of {{budget}}",
    "notInBudget": "Not in budget",
    "meter": "{{category}}: budget used",
    "empty": "Add a budget to see cost against plan.",
    "failed": "The budget figures couldn't be loaded."
  },
  "settings": {
    "dimension": {
      "cost": "Cost",
      "costBody": "When spending runs ahead of the work, a category nears its budget, or the margin shrinks.",
      "schedule": "Schedule",
      "scheduleBody": "When milestones pass their dates or the expected finish moves out.",
      "billing": "Billing and cash",
      "billingBody": "When finished work waits to be invoiced, or the customer pays late.",
      "delivery": "Delivery",
      "deliveryBody": "When an active project goes quiet, its tasks stay blocked, or its team's time isn't submitted.",
      "hygiene": "Record keeping",
      "hygieneBody": "Documents that look like this project's but carry no project.",
      "contract": "Contract",
      "contractBody": "When retention falls due, a guarantee nears its expiry, or claims and variations wait on the client. Only with contracting on.",
      "notifications": "Notifications",
      "notificationsBody": "The people on a project hear about an alert when it is new or gets worse; acknowledged alerts stay quiet until their date."
    },
    "unit": {
      "points": "percentage points",
      "pct": "%",
      "workingDays": "working days",
      "days": "days",
      "perDay": "a day"
    },
    "burnGapPts": {
      "label": "Spend ahead of progress",
      "hint": "Warn when spend runs {{points}} ahead of progress; critical at {{twice}}."
    },
    "categoryTolerancePct": {
      "label": "Category over budget",
      "hint": "Warn when a category's spend and orders pass its budget by more than {{pct}}%."
    },
    "categoryNearPct": {
      "label": "Category near its budget",
      "hint": "Note a category once it has used {{pct}}% of its budget."
    },
    "marginDropPts": {
      "label": "Margin drop",
      "hint": "Warn when the expected margin falls more than {{points}} below the budgeted margin."
    },
    "minProgressForForecastPct": {
      "label": "Cost forecasts start at",
      "hint": "Below {{pct}}% progress or {{pct}}% of the budget spent, the expected final cost is the budget (too early to forecast)."
    },
    "eacMethod": {
      "label": "Expected final cost",
      "hint": "How the expected final cost is worked out from the figures so far.",
      "CPI": "At the cost rate so far",
      "CPIBody": "Budget ÷ cost efficiency (value earned per rial spent). The rest of the work costs what the work so far did.",
      "REMAINING_AT_BUDGET": "The rest of the work at budget",
      "REMAINING_AT_BUDGETBody": "Spent so far plus the budget of the work left. Past overspend is not repeated.",
      "CPI_SPI": "At the cost rate and pace so far",
      "CPI_SPIBody": "Spent so far plus the work left, adjusted for both cost and pace. The most cautious."
    },
    "milestoneCriticalDays": {
      "label": "A late milestone turns critical after",
      "hint": "A milestone past its date is a warning from its first late working day and critical after {{days}}."
    },
    "slipToleranceDays": {
      "label": "Finish slipping",
      "hint": "Warn when the expected finish is more than {{days}} after the planned finish."
    },
    "slipCriticalDays": {
      "label": "Finish slipping badly",
      "hint": "Critical when it is more than {{days}} late."
    },
    "unbilledGraceDays": {
      "label": "Done but not invoiced",
      "hint": "Warn when an achieved billing milestone has no invoice after {{days}}."
    },
    "tmUnbilledDays": {
      "label": "Billable work waiting",
      "hint": "Warn when billable work waits more than {{days}} to be invoiced; critical at {{twice}}."
    },
    "arOverdueDays": {
      "label": "Customer pays late",
      "hint": "Warn when a project invoice is more than {{days}} past its due date."
    },
    "arCriticalDays": {
      "label": "Customer pays very late",
      "hint": "Critical when it is more than {{days}} past its due date."
    },
    "staleDays": {
      "label": "No activity",
      "hint": "Warn when an active project records no progress, cost or task for {{days}}."
    },
    "blockedDays": {
      "label": "Blocked tasks",
      "hint": "Warn when a project task stays blocked for more than {{days}}."
    },
    "overdueTaskDays": {
      "label": "Overdue tasks",
      "hint": "Warn when an open project task is more than {{days}} past its due date."
    },
    "timeSubmitPct": {
      "label": "Time submitted",
      "hint": "Note a member with an allocation who submitted less than {{pct}}% of last week's expected hours; it becomes a warning from the week's second working day."
    },
    "unassignedMinAmount": {
      "label": "Documents without a project",
      "hint": "Note documents of the project's customer or suppliers that carry no project, once they reach {{amount}}."
    },
    "save": "Save insight settings",
    "saved": "Insight settings saved",
    "conflict": "Someone else saved these settings while you were editing. Reload to see their version.",
    "reload": "Reload",
    "range": "Enter a whole number from 0 to {{max}}.",
    "invalid": "Check the highlighted values.",
    "rangeFrom": "Enter a whole number from {{min}} to {{max}}.",
    "retentionLeadDays": {
      "label": "Retention coming due",
      "hint": "Note retention {{days}} before its release date; warn once it is due."
    },
    "bondLeadDays": {
      "label": "Guarantee expiring",
      "hint": "Warn {{days}} before a guarantee expires; critical once it has expired. This sets when the project shows the alert; who is notified, and when, is set in Contracting › Remind before expiry."
    },
    "claimCertDays": {
      "label": "Claim waiting for certification",
      "hint": "Warn when a submitted claim is not certified after {{days}}; critical at {{twice}}."
    },
    "variationPendingDays": {
      "label": "Variation waiting for a decision",
      "hint": "Note a variation still undecided {{days}} after it was submitted."
    },
    "advanceBehindPts": {
      "label": "Advance recovery behind",
      "hint": "Warn when the share of the advance recovered is more than {{points}} behind progress."
    },
    "notifyDailyCap": {
      "label": "Alerts per person a day",
      "hint": "Each person gets at most {{n}} alert notifications a day; the rest arrive together as one summary."
    }
  },
  "trail": {
    "INVOICE": "Invoice",
    "DEBIT_NOTE": "Debit note",
    "CREDIT_NOTE": "Credit note"
  },
  "bondType": {
    "BID": "Bid bond",
    "PERFORMANCE": "Performance bond",
    "ADVANCE_PAYMENT": "Advance payment guarantee",
    "RETENTION": "Retention bond",
    "MAINTENANCE": "Maintenance bond"
  },
  "stored": {
    "trigger": "{{code}} health: {{level}}. Why?",
    "notYet": "Not checked yet",
    "notYetHint": "Health is checked every morning and after changes to the project.",
    "more": "and {{n}} more",
    "none": "No alerts.",
    "notMeasured": "Measured once the project is active, with an approved budget and planned dates.",
    "forecastMargin": "Expected margin",
    "budgetUse": "Budget used",
    "open": "Open Needs attention",
    "filterBy": "Show the projects with this alert: {{name}}"
  },
  "trend": {
    "worse": "Worse than last week: was {{level}}",
    "better": "Better than last week: was {{level}}"
  },
  "ack": {
    "open": "Acknowledge…",
    "title": "Acknowledge this alert",
    "body": "Its notifications stop until the date you choose. It still counts in the project's health, and if it gets worse the acknowledgement ends.",
    "note": "Why",
    "notePlaceholder": "What is being done about it",
    "noteRequired": "Say why.",
    "until": "Until",
    "untilHint": "At most 90 days ahead: {{date}} at the latest.",
    "untilInvalid": "Pick a date from today to {{date}}.",
    "save": "Acknowledge",
    "saved": "Alert acknowledged until {{date}}",
    "by": "Acknowledged by {{name}} until {{date}}",
    "noteJoin": ": ",
    "end": "End acknowledgement",
    "ended": "Acknowledgement ended",
    "notActive": "This alert no longer holds, so there is nothing to acknowledge. Reload the page.",
    "openNamed": "Acknowledge: {{title}}",
    "endNamed": "End acknowledgement: {{title}}"
  }
}
